export const toHtmlString = (obj) => {

  return processElements(obj.child);

}

const processElements = (elements, level = -1) => {
  if(!elements) return "";
  return elements.map(element => {
    if(element.node === "text"){
      return processText(element, level + 1);
    }
    return processElement(element, level + 1);
  }).filter(element => !!element).join("");
}

const processText = (element, level) => {
  const isBreak = element.text.replaceAll("\n", "").replaceAll("\t", "").replaceAll(" ", "") === "";
  console.log("isBreak", {element, isBreak})
  return isBreak ? "" : `\n${indent(level)}${element.text.trim()}`;
}


const processElement = (element, level) => {
  const htmlElements = processElements(element.child, level);
  const htmlAttributes = processAttributes(element.attr);
  return `\n${indent(level)}<${element.tag}${htmlAttributes}>${htmlElements ? `${htmlElements}\n${indent(level)}` : ""}</${element.tag}>`;
}


const processAttributes = (attributes, level) => {
    return attributes 
      ? " " + Object.keys(attributes).reduce((values, key) => {
          return [
            ...values,
            processAttribute(key, attributes[key], level)
          ];
        }, []).join(" ") 
      : "";
}

const processAttribute = (name, value, level) => {
  const value2 = (typeof value === "string" ? value : value.join(" ")) || "";
  let c = "\"";
  if(value2.includes("\"")){
    c = "'";
  }
  return `${name}=${c}${value2.replaceAll(c, "")}${c}`;
}

const indent = (level) => {
  if(level <= 0) return "";
  return fillString(" ", level * 2);
}

const fillString = (str, count) => {
  return new Array(count).fill(str).join("");
}

export const cleanHtmlJson = (obj) => {
  return {...obj, child: cleanElements(obj.child)};
}

const cleanElements = (elements, level = -1) => {
  if(!elements) return;
  return elements.map(element => {
    if(element.node === "text"){
      return cleanText(element);
    }
    return cleanElement(element);
  }).filter(element => !!element);
}

const cleanText = (element) => {
  const isBreak = element.text.replaceAll("\n", "").replaceAll("\t", "").replaceAll(" ", "") === "";
  return isBreak ? undefined : {...element, text: element.text.trim()};
}


const cleanElement = (element) => {
  const elements = cleanElements(element.child);
  //const htmlAttributes = processAttributes(element.attr);
  return {...element, child: elements};
}


const cleanAttributes = (attributes, level) => {
    return attributes 
      ? " " + Object.keys(attributes).reduce((values, key) => {
          return [
            ...values,
            processAttribute(key, attributes[key], level)
          ];
        }, []).join(" ") 
      : "";
}

const cleanAttribute = (name, value, level) => {
  const value2 = (typeof value === "string" ? value : value.join(" ")) || "";
  let c = "\"";
  if(value2.includes("\"")){
    c = "'";
  }
  return `${name}=${c}${value2.replaceAll(c, "")}${c}`;
}
